import {
  ListWorkItemsFilterParameter,
  WorkItemStatus
} from "@wingspanhq/wingspan-api-sdk";

/**
 * The filter every `listWorkItems` read of a single work log should use.
 *
 * Removing a work item from a non-Draft log only soft-deletes it — it lingers
 * as `Inactive` (`workItemService.ts:511-521`) — and the list is paged at 25.
 * Filtering client-side therefore spends the page budget on rows nothing
 * renders, and a log whose first page is all-removed reads as having no work at
 * all (PLA-3662).
 *
 * The server counts an item as work unless it is explicitly `Inactive`
 * (`countActiveByWorkLogId` filters on `$ne: Inactive`), which this allowlist
 * matches only because `WorkItemStatus` has exactly these two members —
 * `ListWorkItemsFilterParameterStatus` offers `anyOf` and nothing else, so a
 * denylist is not expressible. Adding a third status means revisiting this and
 * `filterActiveWorkItems` together.
 */
export const activeWorkItemsFilter = (
  workLogId: string
): ListWorkItemsFilterParameter => ({
  workLogId: { eq: workLogId },
  status: { anyOf: [WorkItemStatus.ACTIVE] }
});
